FiltersMdl.service( 'SubcategoriesSrv', [ '$q', '$http', 'API_URL', function( $q, $http, API_URL ) {

	return {
		getSubCategories: function ( category_id ) {
			var deffered = $q.defer();
			$http.get( API_URL.FILTER + '/sub_categories/' + category_id ).then(
				function(response) {
					deffered.resolve(response.data);
				},
				function (error){
					deffered.reject(error);
				}
			);
			return deffered.promise;
		}
	};
}]);